// src/assets/icons/includes.js
import angular from '@/assets/icons/angular.svg';
import arduino from '@/assets/icons/arduino.svg';
import css3 from '@/assets/icons/css3.svg';
import code from '@/assets/icons/code.svg';
import cpp from '@/assets/icons/cpp.svg';
import docker from '@/assets/icons/docker.svg';
import essay from '@/assets/icons/essay.svg';
import flutter from '@/assets/icons/flutter.svg';
import git from '@/assets/icons/git.svg';
import graphicdesigner from '@/assets/icons/graphicdesigner.svg';
import html5 from '@/assets/icons/html5.svg';
import js from '@/assets/icons/js.svg';
import linux from '@/assets/icons/linux.svg';
import microcontroller from '@/assets/icons/microcontroller.svg';
import pi from '@/assets/icons/pi-logo.jpeg'
import project from '@/assets/icons/project.svg';
import python from '@/assets/icons/python.svg';
import research from '@/assets/icons/research.svg';
import rpi from '@/assets/icons/rpi.svg';
import ruby from '@/assets/icons/ruby.svg';
import survey from '@/assets/icons/survey.svg';
import java from '@/assets/icons/java.svg';
import troubleshoot from '@/assets/icons/troubleshoot.svg';
import vue from '@/assets/icons/vue.svg';

export const all_icons = {
    angular,
    arduino,
    cpp,
    code,
    css3,
    docker,
    essay,
    flutter,
    git,
    graphicdesigner,
    html5,
    java,
    js,
    linux,
    microcontroller,
    pi,
    project,
    python,
    research,
    rpi,
    ruby,
    survey,
    vue,
    troubleshoot
};
